import { useState } from "react";
import { useQuery } from "react-query";
import { getWithResult } from "../../common/api/apiShared";
import { getCountryOptions } from "./PriceCalculator.hooks";
import { WatchPriceCalculationViewModel, WatchPriceSearchFilter, WatchPriceType } from "./PriceCalculator.types";

export function useWatchPriceCalculator() {
    const [searchOptions, setSearchOptions] = useState<WatchPriceSearchFilter>({
        typeOfTransaction: WatchPriceType.WordMark,
        countries: [],
    });

    let url = `/Price-calculator/watch?typeOfTransaction=${searchOptions.typeOfTransaction}&countries=${searchOptions.countries.join("||")}`;
    let { isLoading, data } = useQuery(
        url,
        () =>
            getWithResult<WatchPriceCalculationViewModel>(url)
                .then((r) => {
                    return r.value();
                })
                .catch((e) => {}),
        { enabled: shouldFetch() }
    );

    function shouldFetch() {
        return searchOptions.typeOfTransaction && searchOptions.countries.length > 0;
    }

    return { searchOptions, setSearchOptions, getCountryOptions, isLoading, data };
}
